
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/legal-warning",
      function () {
        return require("private-next-pages/legal-warning.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/legal-warning"])
      });
    }
  